import { List, ListItemButton, ListItemText } from '@mui/material';
import { styled } from '@mui/styles';
import { Link, useLocation } from 'react-router-dom';
import { privateRoute } from 'routes';

const StyledListItem = styled(ListItemButton)({
  borderRadius: 12,
  '&.Mui-selected': {
    backgroundColor: 'var(--color-primary-light) !important',
  },
  '&:hover': {
    backgroundColor: 'var(--color-primary-main) !important',
  },
});

type MenuItemProps = {
  name?: string;
  path: string;
};

const MenuItem = ({ name, path }: MenuItemProps) => {
  const location = useLocation();

  return (
    <Link to={path}>
      <StyledListItem selected={location.pathname.startsWith(path)}>
        <ListItemText classes={{ primary: 'font-medium' }}>{name}</ListItemText>
      </StyledListItem>
    </Link>
  );
};

const Menu = () => {
  const { home, itemList, fragmentList, collectionList, userList } = privateRoute;

  return (
    <List className='flex flex-col gap-1'>
      <MenuItem {...home} />
      <MenuItem {...itemList} />
      <MenuItem {...fragmentList} />
      <MenuItem {...collectionList} />
      <MenuItem {...userList} />
    </List>
  );
};

export default Menu;
